module.exports = __webpack_public_path__ + "b9dc2d0560515855cc9fd33e378fb55f.jpg";